import React from 'react';

export default function SkeletonLoader() {
  return (
    <div className="ri-page ri-skeleton" aria-busy="true" aria-label="Loading restaurant information">
      <div className="ri-skeleton-hero" />
      <div className="ri-skeleton-content">
        <div className="ri-skeleton-line ri-skeleton-line--title" />
        <div className="ri-skeleton-line" />
        <div className="ri-skeleton-line" />
        <div className="ri-skeleton-line ri-skeleton-line--short" />
        <div className="ri-skeleton-block" />
        <div className="ri-skeleton-line" />
        <div className="ri-skeleton-line" />
        <div className="ri-skeleton-line ri-skeleton-line--short" />
      </div>
    </div>
  );
}
